import { render } from "./MainListOfAccountsPayablePayments.vue?vue&type=template&id=545be23e&scoped=true"
import script from "./MainListOfAccountsPayablePayments.vue?vue&type=script&lang=js"
export * from "./MainListOfAccountsPayablePayments.vue?vue&type=script&lang=js"

import "./MainListOfAccountsPayablePayments.vue?vue&type=style&index=0&id=545be23e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545be23e"]])

export default __exports__